// @flow

import React from 'react';
import styled from 'styled-components';
import { flex, maxWidths, topMargin, widths } from 'styles';
import { ImageLoader } from 'components/Gui';
import { useImages } from 'hooks';
import type { AllImages } from 'hooks/use-images';
import type { Props as ImageLoaderProps } from 'components/Gui/ImageLoader';

const Wrapper = styled.div`
  ${({ marginTop }) => marginTop && topMargin(...marginTop)};
  ${({ wrapperWidths }) => widths(...wrapperWidths)};
  ${flex()};
`;

const Image = styled.div`
  position: relative;
  width: 100%;
  ${({ imageMaxWidths }) => imageMaxWidths && maxWidths(...imageMaxWidths)};
`;

type Props = {
  marginTop?: number[],
  wrapperWidths?: Array<number | string>,
  imageMaxWidths?: Array<number | string>,
  name: string,
  images: AllImages,
};

const ImageContainer = ({ marginTop, wrapperWidths = ['100%'], imageMaxWidths, images, name, ...rest }: Props & ImageLoaderProps) => {
  const getImage = useImages(images);
  return (
    <Wrapper marginTop={marginTop} wrapperWidths={wrapperWidths}>
      <Image imageMaxWidths={imageMaxWidths}>
        <ImageLoader image={getImage(name)} {...rest} />
      </Image>
    </Wrapper>
  );
};

ImageContainer.contentType = 'ImageContainer';

export default ImageContainer;
